import { cn } from '@/lib/utils'

export interface LegendItem {
  label: string
  /** A fill class matching the mark: `bg-chart-1`. */
  swatch: string
  /** A count or total beside the label. */
  value?: number | string
}

/** The key under a chart. Text stays in text colours; the swatch carries the
 *  series colour. */
export function Legend({ items, className }: { items: LegendItem[]; className?: string }) {
  return (
    <ul className={cn('flex flex-wrap items-center gap-x-4 gap-y-1 text-meta text-muted-foreground', className)}>
      {items.map((it) => (
        <li key={it.label} className="inline-flex items-center gap-1.5">
          <span aria-hidden className={cn('h-2.5 w-2.5 shrink-0 rounded-sm', it.swatch)} />
          {it.label}
          {it.value !== undefined && <span className="tabular-nums text-foreground">{typeof it.value === 'number' ? it.value.toLocaleString('ko-KR') : it.value}</span>}
        </li>
      ))}
    </ul>
  )
}
